// this is used to convert the string properties on incoming objects to uppercase since the mobile app is uppercase only

export class ObjectUtils {
    // eslint-disable-next-line
    static convertToUppercase(object) {
        if (object == null) return object;

        if (Array.isArray(object)) {
            return this.uppercaseArrayContents(object);
        }

        return this.uppercaseObjectProperties(object);
    }

    // eslint-disable-next-line
    static uppercaseArrayContents(theArray) {
        let result = [];

        for (let i = 0; i < theArray.length; i++) {
            result.push(this.convertToUppercase(theArray[i]));
        }

        return result;
    }

    /** Field names that must not be uppercased (e.g. emails, __typename, signature). */
    // eslint-disable-next-line
    static get nonUppercaseFieldNames() {
        return ["__typename", "signature", "signatory_email", "contact_email", "email", "email_work", "email_home"];
    }

    // eslint-disable-next-line
    static uppercaseObjectProperties(object) {
        let result = {};
        for (const [fieldName, fieldValue] of Object.entries(object)) {
            if (typeof fieldValue === "object" && fieldValue) {
                // if the field is another object, recurse through it
                result = { ...result, [fieldName]: this.convertToUppercase(fieldValue) };
            } else if (typeof fieldValue === "string" && !this.nonUppercaseFieldNames.includes(fieldName)) {
                // convert strings to uppercase except for __typename, signature, and email fields
                result = { ...result, [fieldName]: fieldValue.toLocaleUpperCase() };
            } else {
                // don't touch anything else
                result = { ...result, [fieldName]: fieldValue };
            }
        }

        return result;
    }
}
